/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_AuthInputs */



/**
* | output |
* | --- |
* | "we could not authenticate with GitHub" |
*
* @param {Twda_Failed_AuthInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_auth = /** @type {((inputs?: Twda_Failed_AuthInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_AuthInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("l'authentification auprès de GitHub a échoué")
	if (locale === "es") return /** @type {LocalizedString} */ ("no se pudo autenticar con GitHub")
	if (locale === "pt") return /** @type {LocalizedString} */ ("não foi possível autenticar no GitHub")
	if (locale === "it") return /** @type {LocalizedString} */ ("autenticazione con GitHub non riuscita")
	return /** @type {LocalizedString} */ ("we could not authenticate with GitHub")
});